import { render } from "./ErrorPopin.vue?vue&type=template&id=65292b69&scoped=true&ts=true"
import script from "./ErrorPopin.vue?vue&type=script&lang=ts"
export * from "./ErrorPopin.vue?vue&type=script&lang=ts"

import "./ErrorPopin.vue?vue&type=style&index=0&id=65292b69&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65292b69"]])

export default __exports__